<template lang='pug' src='./video-modal.pug'></template>

<script>

export default {
  props: ['props'],
  methods: {
    close () {
      this.$store.dispatch('VIEW_SHOWVIDEO', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// video-modal.vue?cf722ec4